<template>
  <div class="rootDiv">
    <img :src="viewModel.jDTP" :width="width" alt="">
    <div class="title-div">
      <span>{{ viewModel.jDMC }}</span>
    </div>
    <Cell class="cell" title="星级">
      <span>{{ viewModel.xJ }}</span>
    </Cell>
    <Cell class="cell" title="评分">
      <span>{{ viewModel.jDPF }}</span>
    </Cell>
    <Cell class="cell" title="城市">
      <span>{{ viewModel.jDCS }}</span>
    </Cell>
    <Cell class="cell" title="地址">
      <span>{{ viewModel.jDDZ }}</span>
    </Cell>
    <Cell class="cell" title="经度">
      <span>{{ viewModel.jDJD }}</span>
    </Cell>
    <Cell class="cell" title="纬度">
      <span>{{ viewModel.jDWD }}</span>
    </Cell>
    <Cell class="cell" title="酒店电话" v-if="viewModel.jDDH">
      <span>{{ viewModel.jDDH }}</span>
    </Cell>
    <Cell title="查看地图"
          style="margin-bottom: 10px;text-align: left;min-height: 40px;color: blue" is-link
          v-on:click.native="goMap()"></Cell>
    <Cell title="百度百科"
          style="margin-bottom: 10px;text-align: left;min-height: 40px;color: blue" is-link
          v-on:click.native="goBaiDu(viewModel.jDMC )"></Cell>
  </div>
</template>

<script>
import {Cell, Indicator} from "mint-ui";

export default {
  name: "HotelDetails",
  data() {
    return {
      viewModel: {},
      width: document.documentElement.clientWidth,
      getHotelDetailsUrl: '/api/whhly/getHotelDetails',
    }
  },
  components: {
    Cell
  },
  mounted() {
    if (this.$route.params.viewModel === undefined && this.$route.params.id === undefined) {
      this.$router.go(-1)
    } else if (this.$route.params.viewModel !== undefined)
      this.viewModel = this.$route.params.viewModel
    else
      this.getDetails(this.$route.params.id)
  },
  methods: {
    goMap() {
      if (this.viewModel.jDJD === 0 || this.viewModel.jDWD === 0) {
        this.$messagebox.alert('缺少经纬度坐标')
      } else {
        let list = []
        let item = {title: this.viewModel.jDMC, data: this.viewModel}
        list.push(item)
        this.$router.replace({name: 'm_hotel_map', query: {point: list}})
      }
    },
    goBaiDu(name) {
      window.location.href = "https://baike.baidu.com/item/" + name
    },
    getDetails(id) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getHotelDetailsUrl,
        params: {id: id},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          that.viewModel = response.data['responseData']
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.title-div {
  background-color: #8450C5;
  margin-right: -0.5rem;
  padding-bottom: 5px;
  margin-top: -0.1rem;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
  margin-left: -0.5rem;
}

.cell {
  text-align: left;
}

/deep/ .mint-cell-title {
  min-width: 80px;
}
</style>
